import { cn } from '@/lib/utils';

const DotBackground = ({
  children,
  className,
  wrapperClassName,
  isCanvas = false,
  inset = false,
  fixedDots = false,
}: {
  children: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
  isCanvas?: boolean;
  /**
   * A dotted well INSIDE a pane, card or dialog. Light keeps the dotted sheet;
   * dark paints neither fill nor dots, so the surface holding it shows
   * through — the canvas colour inside a surface reads as a sunk hole, and
   * its dots as a fourth layer (elevation.ts, design review 2026-10).
   */
  inset?: boolean;
  /**
   * Anchor the dots to the viewport, like the app Layout's canvas
   * (`bg-dotted-pattern bg-fixed`), so this patch lines up with the page
   * around it — the page loader, which hands over from full-screen to in-page.
   */
  fixedDots?: boolean;
}) => {
  return (
    <div
      className={cn(
        'relative flex h-full w-full items-center justify-center bg-background',
        !isCanvas && 'overflow-clip rounded-3xl',
        isCanvas && 'overflow-y-clip',
        inset && 'dark:bg-transparent',
        className,
      )}>
      <div
        className={cn(
          'absolute inset-0',
          `[background-size:10px_10px]`,
          // The dots are the `--dot-rgb` token, per theme.
          `[background-image:radial-gradient(rgb(var(--dot-rgb))_1.5px,transparent_0px)]`,
          inset && 'dark:hidden',
          fixedDots && 'bg-fixed',
        )}
      />
      <div
        className={cn(
          'isolate flex h-full w-full items-center justify-center',
          wrapperClassName,
        )}>
        {children}
      </div>
    </div>
  );
};

export default DotBackground;
